import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, Typography, Button } from "@material-ui/core";
import ReCaptcha from "../../kyc/components/ReCaptcha";

interface GoogleReCaptchaModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const GoogleReCaptchaModal: React.FC<GoogleReCaptchaModalProps> = ({ open, onClose, onSuccess }) => {
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    if (open) {
      setIsVerified(false);
    }
  }, [open]);

  const handleVerify = (verified: boolean) => {
    setIsVerified(verified);
    if (verified) {
      // Save timestamp to localStorage (valid for duration e.g. 15 mins)
      localStorage.setItem("sell_captcha_verified_at", Date.now().toString());
      setTimeout(() => {
        onSuccess();
      }, 500);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          onClose();
        }
      }}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "16px",
          padding: "0.5rem",
          boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
          overflow: "hidden"
        },
      }}
    >
      <DialogContent style={{ padding: "1.5rem", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", overflow: "hidden" }}>
        <span style={{ fontSize: "0.65rem", fontWeight: 700, letterSpacing: "1.5px", color: "#d92b3c", textTransform: "uppercase", marginBottom: "0.25rem" }}>
          SECURITY CHECK
        </span>
        <Typography variant="h6" style={{ fontWeight: "bold", fontFamily: '"Playfair Display", serif', color: "#1A1A1A", marginBottom: "0.5rem" }}>
          Verify you are human
        </Typography>
        <Typography style={{ fontSize: "0.85rem", color: "#666", marginBottom: "1.5rem" }}>
          Please complete the reCAPTCHA verification to continue with photo analysis.
        </Typography>

        <div style={{ display: "flex", justifyContent: "center", marginBottom: "1.5rem", width: "100%" }}>
          <ReCaptcha setIsVerfied={handleVerify} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GoogleReCaptchaModal;
